import { ArrowLeft } from "@phosphor-icons/react";
import { Link } from "react-router-dom";

export const SiteTopBar = () => (
  <header className="fixed top-0 z-50 w-full border-b border-black/5 bg-white/85 py-3 backdrop-blur-xl">
    <div className="mx-auto flex max-w-8xl items-center justify-between px-5 md:px-10">
      <Link to="/" className="flex items-center gap-2" data-testid="subpage-brand-logo">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-maraca-navy font-display text-lg font-extrabold text-white">M</span>
        <span className="font-display text-xl font-extrabold tracking-tight text-maraca-navy">
          Delivery <span className="text-maraca-teal">Maracás</span>
        </span>
      </Link>
      <Link
        to="/"
        data-testid="subpage-back-home"
        className="inline-flex items-center gap-2 rounded-full border border-black/10 px-4 py-2 text-sm font-bold text-maraca-navy transition-colors hover:bg-maraca-teal/10"
      >
        <ArrowLeft size={18} weight="bold" /> Voltar ao site
      </Link>
    </div>
  </header>
);
